/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { SponsoredCompanyRow, fmtDate, getSubscriptionEndDate, getSubscriptionStartDate } from '../utils';
import { Subscription } from '../../../types/initiative';
import { Button, ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { GanttChart } from './SubscriptionGanttChart';

const STRIPE_URL = 'https://dashboard.stripe.com/test/';

export const CompanySubscriptionHistoryModal = (props: SponsoredCompanyRow & { toggle: () => void }) => {
  const { toggle } = props;

  const sort = (a: Subscription, b: Subscription) => {
    return a.periodStart > b.periodStart ? 1 : a.periodStart < b.periodStart ? -1 : 0;
  }

  return (
    <Modal size='xl' isOpen={true} toggle={toggle} backdrop='static' className='sponsorship-modal'>
      <ModalHeader toggle={toggle}>{props.name}</ModalHeader>
      <ModalBody>
        <GanttChart {...props} />
        <div className='text-right'>
          <Button color='link' onClick={() => window.open(STRIPE_URL + 'customers/' + props.customerId)}>
            <i className='fal fa-user mr-2' />View customer on Stripe
          </Button>
        </div>

        <ListGroup>
          {props.subscriptions.sort(sort).map(sub => (
            <ListGroupItem className='subs-item' key={`sub-item-${sub.id}`}>
              <div className={`subs-item-heading strong d-flex justify-content-between sub-status-${sub.status}`}>
                <div>
                  {fmtDate(getSubscriptionStartDate(sub))} - {fmtDate(getSubscriptionEndDate(sub))}
                  <Button color='link' onClick={() => window.open(STRIPE_URL + 'subscriptions/' + sub.id)}>
                    <i className='fal fa-dollar' />
                  </Button>
                </div>
                <div>
                  {sub.status.toLocaleUpperCase()}
                </div>
              </div>
              {sub.discount ? (
                <div>
                  Sponsored until {fmtDate(sub.discount.end)}
                  <Button color='link' onClick={() => window.open(STRIPE_URL + 'discounts/' + sub.discount?.id)}>
                    <i className='fal fa-ticket' />
                  </Button>
                </div>
              ) : null
              }
              <div>
                Subscription: {fmtDate(sub.startDate)} to {fmtDate(sub.endDate)}
                {sub.cancelDate ? ` Cancel: ${fmtDate(sub.cancelDate)}` : ''}
              </div>
              <div>Period: {fmtDate(sub.periodStart)} to {fmtDate(sub.periodEnd)}</div>
            </ListGroupItem>
          ))}
        </ListGroup>
      </ModalBody>
    </Modal>
  );
}
